const PlusSignIcon = /*#__PURE__*/ [
  ["path", { d: "M12 4V20M20 12H4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { PlusSignIcon as default };
//# sourceMappingURL=PlusSignIcon.js.map
